module.exports = __webpack_public_path__ + "icons/original/small/small-e5.46811d66ca231366ab2e44b4de32bee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-e5.png
// module id = P2+R
// module chunks = app